import axios from "axios";
import { api } from "../../../api";

const root = process.env.REACT_APP_BACKEND_FINANCE_SERVICE_URL;
const route = api(root);
const token = JSON.parse(localStorage.getItem("user"))?.userToken;

/**ALL API CALL FUNCTIONS EXPORTED AS AN OBJECT OF METHODS */

const CostCenterService = {
    // Create cost class
    async createClass(formData) {
        let { data } = await route.post(
        "/costcenterclass",
        formData,
        {
            headers: {
                Authorization: "Bearer " + token,
            },
        }
        );
        // console.log({createClass: data})

        return data;
    },

    // Get all cost classes
    async getAllClasses({ pageNumber, pageSize, search, status }) {
        let { data } = await route.get(
        `/CostCenterClass/GetAllCostCenterClass?PageSize=${pageSize}&PageNumber=${pageNumber}&Search=${search}&Status=${status}`,
        {
            headers: {
            Authorization: "Bearer " + token,
            },
        }
        );
        // console.log({ allClasses: data })

        return data.responseObject;
    },

    // Approve/Decline cost class
    async approveDeclineClass(formData) {
        let { data } = await route.post(
        "/CostCenterClass/ApproveDeclineCC",
        formData,
        {
            headers: {
                Authorization: "Bearer " + token,
            },
        }
        );
        console.log({AD_Class: data})

        return data;
    },

    // Update cost class
    async updateClass(formData) {
        let { data } = await route.post(
        "/CostCenterClass/update",
        formData,
        {
            headers: {
            Authorization: "Bearer " + token,
            },
        }
        );
        console.log({updateClass: data})

        return data;
    },

    // Disable cost class
    async disableClass(formData) {
        let { data } = await route.post(
        "/CostCenterClass/delete",
        formData,
        {
            headers: {
            Authorization: "Bearer " + token,
            },
        }
        );
        console.log({disableClass: data})

        return data;
    },

    // Get Account, Cadres(Levels), Departments, Branches, and Employees
    async FetchChartOfAccounts(){
        try{
            let { data } = await axios.get(`${root}/accountledgersetup/accountledger?PageSize=100&PageNumber=1`,{
              headers: {
                Authorization: "Bearer " + token
              }
            })
            console.log({ accounts: data})
            return data?.responseObject;
        } catch (e) {
            console.log({err: e.response.data || e})
        }
    },
    async getAllCadres() {
        try {
        let { data } = await axios.get(
            "https://bpmapi-dev.nlpcpfa.com/HRService/api/EmployeeCadrePosition?PageSize=1000&PageNumber=1&Status=0",
            {
            headers: {
                Authorization: "Bearer " + token,
            },
            }
        );
        console.log({cadres: data})

        return data?.result;
        } catch (e) {
            console.error({ err: e.response || e });
            return [];
        }
    },
    async getAllContainers() {
        try {
        let { data } = await axios.get(
            "https://bpmapi-dev.nlpcpfa.com/HRService/api/Container/AllContainer?PageSize=100&PageNumber=1",
            {
            headers: {
                Authorization: "Bearer " + token,
            },
            }
        );
        console.log({Branch: data})
        return data.responseObject.pageItems;
        } catch (e) {
        console.error({ err: e.response || e });
        }
    },
    async getAllDepts() {
        try {
        let { data } = await axios.get(
            "https://bpmapi-dev.nlpcpfa.com/HRService/api/Department/AllDepartment?PageSize=100&PageNumber=1",
            {
            headers: {
                Authorization: "Bearer " + token,
            },
            }
        );

        return data.responseObject.pageItems;
        } catch (e) {
        console.log({ deptError: e.response.data || e });
        return e.response.data;
        }
    },
    async getAllEmployees(Search = "") {
        try {
            let { data } = await axios.get(
                `https://bpmapi-dev.nlpcpfa.com/HRService/api/Employee/GetAllEmployees?PageSize=100&PageNumber=1&Search=${Search}`,
                {
                headers: {
                    Authorization: "Bearer " + token,
                },
                }
            );
            console.log({ employeesData: data});
            return data.result;
        } catch (e) {
            console.log({ errEmployees: e.response.data || e });
            return [];
        }
    },

    // Create table data POST method
    async createCostService(formData) {
        console.log({kreate: formData})
        try {
        let { data } = await route.post("/costcenter", formData, {
            headers: {
                Authorization: "Bearer " + token,
            },
        });
        // console.log({ createCostService: data });

        
        return data;
        } catch (e) {
        console.log({ err: e.response.data || e });
        }
    },

    // Get all created table data
    async getCostServices({
        Search,
        Status,
        Dept='',
        Employee='',
        Branch='',
        Cadre='',
        CostClassID,
        PageSize,
        PageNumber,
        OrganizationStructure
    }) {
        try {
        let { data } = await route.get(
            `/CostCenter/all?PageSize=${PageSize}&PageNumber=${PageNumber}&Search=${Search}&CostClassID=${CostClassID}&OrganizationStructure=${OrganizationStructure}&Status=${Status}&Employee=${Employee}&Branch=${Branch}&Cadre=${Cadre}&Dept=${Dept}`,
            {
            headers: {
                Authorization: "Bearer " + token,
            },
            }
        );

        console.log({ getCostServices: data });

        return data;
        } catch (err) {
            console.log({ getCostError: err.response.data || err });
        }
    },

    //Get single cost service
    async getCostService(id) {
        try {
            let { data } = await route.get(`/CostCenter/${id}`, {
                headers: {
                    Authorization: "Bearer " + token,
                },
            });
            // console.log({ id, getCostService: data });
            return data.responseObject;
        } catch (err) {
            console.log({ err: err.response.data || err });
        }
    },

    //Update the cost service
    async updateCostService(formData) {
        let { data } = await route.post("/CostCenter/update", formData, {
        headers: {
            Authorization: "Bearer " + token,
        },
        });
        console.log({ updateCostService: data });
        return data;
    },

    //Approve/Decline Cost Service
    async approveDeclineCostService(formData) {
        let { data } = await route.post("/CostCenter/approveDeclineCostCenter", formData, {
        headers: {
            Authorization: "Bearer " + token,
        },
        });
        console.log({ approveDeclineCostService: data });
        return data;
    },

    //Delete the cost service
    async deleteCostService(id) {
        let { data } = await route.post(
        "/CostCenter/delete",
        { id, statusEnum: 2 },
        {
            headers: {
            Authorization: "Bearer " + token,
            },
        }
        );
        console.log({ deleteCostService: data });
        return data;
    },

   // Get all expenses table data
    async getCostExpenses({search="", costClassID, organizationStructure, pageSize, pageNumber}){
        try{
            let { data } = await route.get(`/CostCenterExpenses/all?&PageSize=${pageSize}&PageNumber=${pageNumber}&CostClassID=${costClassID}&Search=${search}&OrganizationStructure=${organizationStructure}`, 
            {
                headers: {
                    Authorization: 'Bearer ' + token,
                }
            })
            console.log({ url: `/CostCenterExpenses/all?&PageSize=${pageSize}&PageNumber=${pageNumber}&CostClassID=${costClassID}&Search=${search}&OrganizationStructure=${organizationStructure}`, costExpenses: data})
            return data
        }
        catch (err) {
            console.log({getCostError: err.response.data || err})
        }
    },

    async getExpense(id){
        axios.get('https://bpmapi-dev.nlpcpfa.com/FinanceService/api/CostCenter/GetCostCenterExpensesQueryById?id=1', {
            headers: {
                Authorization: 'Bearer ' +token,
            }
        })
        .then(({data})=> console.log({data}))
    }

}

export default CostCenterService;
